import React, { useEffect, useState } from "react";
import {
  fetchFormData,
  formatTimeOnly,
  formatDateOnly,
} from "../../utils/options";
import Footer from "../shared/Footer";
import OpenLoanLeads2Header from "./OpenLoanLeads2Header";
import Header from "../shared/header/Header";
import NavigationMenu from "../shared/navigationMenu/NavigationMenu";
import PageHeader from "../shared/pageHeader/PageHeader";
import { useParams } from "react-router-dom";
import Table from "../shared/table/Table";

const OpenLoanLeadsHistory = () => {
  const { id: convertedId } = useParams();
  const [History, setHistory] = useState([]);
  const [Details, setDetails] = useState([]);
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    if (convertedId) {
      fetchTaskHistory(convertedId);
      fetchTaskDetails(convertedId);
    }
  }, [convertedId]);

  const fetchTaskDetails = async (id) => {
    try {
      const formData = new FormData();
      formData.append("id", id);

      const result = await fetchFormData(
        "get-lead-inquiry-by-id",
        formData,
        "POST"
      );
      if (result && result.data) {
        setDetails(result.data);
      } else {
        setDetails({});
      }
    } catch (error) {
      console.error("Failed to fetch task details:", error);
      setDetails({});
    }
  };

  const fetchTaskHistory = async (id) => {
    setLoading(true);
    try {
      const response = await fetchFormData(
        `getLoan-inquiry-history/${id}`,
        {},
        "POST"
      );

      if (response?.data) {
        setHistory(response.data);
      } else {
        setHistory([]);
      }
    } catch (error) {
      console.error("Failed to fetch task history:", error);
      setHistory([]);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      accessorKey: "ActionDetails",
      header: "Action Details",
      cell: ({ row }) => {
        const field = row.original.field || "Unknown Field";
        const changedBy = row.original.changed_by_name || "Unknown User";
        const changedAtRaw = row.original.changed_at;

        const formatDate = (dateString) => {
          if (!dateString) return "-";
          const date = new Date(dateString);
          if (isNaN(date)) return dateString; // Not a valid date
          const day = String(date.getDate()).padStart(2, "0");
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const year = date.getFullYear();
          return `${day}-${month}-${year}`;
        };

        const formattedOldValue = formatDate(row.original.old_value);
        const formattedNewValue = formatDate(row.original.new_value);

        const formattedChangedAt = formatDate(changedAtRaw);

        return `${changedBy} changed ${field} from ${formattedOldValue} to ${formattedNewValue}.`;
      },
      defaultIsVisible: true,
    },
    {
      accessorKey: "changed_at",
      header: "Action Date",
      cell: (info) => formatDateOnly(info.getValue()),
      defaultIsVisible: true,
    },
    {
      accessorKey: "changed_at",
      header: "Action Time",
      cell: (info) => formatTimeOnly(info.getValue()),
      defaultIsVisible: true,
    },
    {
      accessorKey: "changed_by_name",
      header: "Action Change By",
      defaultIsVisible: true,
      cell: ({ getValue }) => {
        const name = getValue();
        return name ? name.charAt(0).toUpperCase() + name.slice(1) : "";
      },
    },
  ];

  return (
    <>
      <Header />
      <NavigationMenu />
      <main className="nxl-container">
        <div className="nxl-content">
          <PageHeader></PageHeader>
          <OpenLoanLeads2Header />

          <div className="main-content">
            <div className="row">
              <div className="task-details mb-6 lead-form-style">
                <h5 className="section-title">Inquiry Converted Details</h5>
                <form className="details-font">
                  {/* Row 1 */}
                  <div className="row mb-3">
                    <div className="col-2 fw-semibold">Inquiry Id:</div>
                    <div className="col-2">{Details.Inquiries_Id || "-"}</div>

                    <div className="col-2 fw-semibold">Customer Name:</div>
                    <div className="col-2">{Details.customer_name || "-"}</div>

                    <div className="col-2 fw-semibold">Phone Number:</div>
                    <div className="col-2">{Details.phone_number || "-"}</div>
                  </div>

                  {/* Row 2 */}
                  <div className="row mb-3">
                    <div className="col-2 fw-semibold">Email:</div>
                    <div className="col-2">{Details.email}</div>

                    <div className="col-2 fw-semibold">Address:</div>
                    <div className="col-2">{Details.address || "-"}</div>

                    <div className="col-2 fw-semibold">State:</div>
                    <div className="col-2">{Details.state_name || "-"}</div>
                  </div>

                  {/* Row 3 */}
                  <div className="row mb-3">
                    <div className="col-2 fw-semibold">District:</div>
                    <div className="col-2">{Details.district_name || "-"}</div>

                    <div className="col-2 fw-semibold">City:</div>
                    <div className="col-2">{Details.city_name || "-"}</div>
                    <div className="col-2 fw-semibold">Inquiry Amount:</div>
                    <div className="col-2">{Details.loan_amount || "-"}</div>
                  </div>

                  {/* Row 4 */}
                  <div className="row mb-3">
                    <div className="col-2 fw-semibold">Inquiry Source:</div>
                    <div className="col-2">
                      {Details.lead_source_name || "-"}
                    </div>

                    <div className="col-2 fw-semibold">Inquiry Type:</div>
                    <div className="col-2">{Details.loan_type_name || "-"}</div>
                    <div className="col-2 fw-semibold">Inquiry Priority:</div>
                    <div className="col-2">{Details.lead_priority || "-"}</div>
                  </div>

                  {/* Row 5 */}
                  <div className="row mb-3">
                    <div className="col-2 fw-semibold">
                      Inquiry Application Number:
                    </div>
                    <div className="col-2">
                      {Details.LoanApplicationNumber || "-"}
                    </div>

                    <div className="col-2 fw-semibold">Transition ID:</div>
                    <div className="col-2">{Details.TransitionID || "-"}</div>
                    <div className="col-2 fw-semibold">Inquiry Status:</div>
                    <div className="col-2">
                      {Details.loan_inquiry_status || "-"}
                    </div>
                  </div>

                  {/* row 6 */}
                  <div className="row mb-3">
                    <div className="col-2 fw-semibold">Prefer Bank:</div>
                    <div className="col-2">{Details.preferbankname || "-"}</div>
                    <div className="col-2 fw-semibold">Payouts Type:</div>
                    <div className="col-2">{Details.payouts_type || "-"}</div>

                    <div className="col-2 fw-semibold">PayoutDate:</div>
                    <div className="col-2">{Details.PayoutDate || "-"}</div>
                  </div>

                  {/* row 7 */}
                  <div className="row mb-3">
                    <div className="col-2 fw-semibold">Payouts Amount:</div>
                    <div className="col-2">{Details.payouts || "-"}</div>
                    <div className="col-2 fw-semibold">Inquiry Date:</div>
                    <div className="col-2">
                      {Details.inquiry_date
                        ? formatDateOnly(Details.inquiry_date)
                        : "-"}
                    </div>
                    <div className="col-2 fw-semibold">Inquiry Notes:</div>
                    <div className="col-2">{Details.inquiry_notes || "-"}</div>
                  </div>

                  {/* row 8 */}
                  <div className="row mb-3">
                    <div className="col-2 fw-semibold">Assigned User:</div>
                    <div className="col-2">{Details.assigned_user || "-"}</div>

                    <div className="col-2 fw-semibold">Created User:</div>
                    <div className="col-2">
                      {Details.created_user
                        ? Details.created_user.charAt(0).toUpperCase() +
                          Details.created_user.slice(1)
                        : "-"}
                    </div>

                    <div className="col-2 fw-semibold">Converted Date:</div>
                    <div className="col-2">
                      {Details.converted_date
                        ? formatDateOnly(Details.converted_date)
                        : "-"}
                    </div>
                  </div>

                  {/* row 9 */}
                  <div className="row mb-3">
                    <div className="col-2 fw-semibold">Follow Up Date:</div>
                    <div className="col-2">
                      {Details.converted_date
                        ? formatDateOnly(Details.follow_up_date)
                        : "-"}
                    </div>
                  </div>

                  {/* Row 3 (Full width for details) */}
                </form>
              </div>
              <Table data={History} columns={columns} loading={loading} />
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default OpenLoanLeadsHistory;
